import React, { Component } from 'react'
import { getOrganisationApi, getPutOrganisationApi } from '../services/apiService'
import { Form, Input, Button } from 'antd';



export class Organization extends Component {
  constructor(props) {
    super(props)
    this.state = { Organization: {} };
  }

  componentDidMount() {

    getOrganisationApi(window.sessionStorage.getItem("OrganisationId"))
      .then(json => {
        if (typeof json === 'string') {
          throw new Error(json)
        } else {
          this.setState({ Organization: json })
        }
      })
      .catch(error => {
        //console.error("Error loading organisation data: " + error)
        alert(error);
      })

  }

  handleSubmit = (e) => {
    e.preventDefault();
    //console.log("submitting...");
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let newValues = { ...this.state.Organization, ...values }
        this.save( newValues )
        //console.log("form values: ", newValues);
        //this.setState({ Organization: newValues })
      } else {
        console.error(err)
      }

    })
  }

  save = (data) => {
    getPutOrganisationApi(data.id, data)
      .then(
        this.setState({ Organization: data })
      ).catch(error => {
        console.error("Error saving organisation data: " + error)
        alert(error);
      })
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    let { organisationName = '',
      building = '',
      address = '',
      suburb = '',
      city = '',
      postCode = '',
      fax = '',
      www = '',
      phone = '',
      orgKey = '',
      accessCode = '',
      country = ''
    } = this.state.Organization;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 10 },
      },
    };

    const formTailLayout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 4, offset: 6 },
    };

    return (
      <div className="content">
        <h2>{this.props.title}</h2>
        <Form layout='vertical' onSubmit={this.handleSubmit} >
          <Form.Item {...formItemLayout} label="Unique Key:">
            <div >{orgKey} </div>
          </Form.Item>
          <Form.Item {...formItemLayout} label="Organisation Name:">
            {getFieldDecorator('organisationName', {
              initialValue: organisationName
            })(
              <Input />
            )}
          </Form.Item>
          <Form.Item {...formItemLayout} label="Building:">
            {getFieldDecorator('building', {
              initialValue: building
            })(
              <Input />
            )}
          </Form.Item>
          <Form.Item {...formItemLayout} label="Address:">
            {getFieldDecorator('address', {
              initialValue: address
            })(
              <Input />
            )}
          </Form.Item>
          <Form.Item {...formItemLayout} label="Suburb:">
            {getFieldDecorator('suburb', {
              initialValue: suburb
            })(
              <Input />
            )}
          </Form.Item>
          <Form.Item {...formItemLayout} label="City:">
            {getFieldDecorator('city', {
              initialValue: city
            })(
              <Input />
            )}
          </Form.Item>
          <Form.Item {...formItemLayout} label="Postcode:">
            {getFieldDecorator('postCode', {
              initialValue: postCode
            })(
              <Input />
            )}
          </Form.Item>
          <Form.Item {...formItemLayout} label="Country:">
            {getFieldDecorator('country', {
              initialValue: country
            })(
              <Input />
            )}
          </Form.Item>
          <Form.Item {...formItemLayout} label="Phone:">
            {getFieldDecorator('phone', {
              initialValue: phone
            })(
              <Input />
            )}
          </Form.Item>
          <Form.Item {...formItemLayout} label="Fax:">
            {getFieldDecorator('fax', {
              initialValue: fax
            })(
              <Input />
            )}
          </Form.Item>
          <Form.Item {...formItemLayout} label="www:">
            {getFieldDecorator('www', {
              initialValue: www
            })(
              <Input />
            )}
          </Form.Item>
          <Form.Item {...formItemLayout} label="Access Code:">
            {getFieldDecorator('accessCode', {
              initialValue: accessCode
            })(
              <Input />
            )}
          </Form.Item>
          <Form.Item {...formTailLayout}>
            <Button type="primary" htmlType="submit">Submit</Button>
          </Form.Item>
        </Form>
      </div>
    )
  }
}

const FormOrganization = Form.create({ name: 'organization' })(Organization);


export default FormOrganization;
